import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class HeaderService {
  constructor(private http: HttpClient) {}

  downloadExcel = (url: string) => {
    return this.http.get(url, { responseType: 'blob' });
  };

  getProcessLogDetails(portfolioId: number) {
    const processLogLinkApiUrl = 'api/processedData/processLogUrl';
    return this.http.get<{ url: string; fileExists?: boolean }>(`${processLogLinkApiUrl}/${portfolioId}`);
  }
}
